import { gallery } from "@/mocks/content";

export default function Gallery() {
  return (
    <section id="gallery" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="mb-10 max-w-2xl">
          <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
            <i className="ri-image-2-fill"></i>
            沙雕图集
          </span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">
            每一张都能直接当表情包
          </h2>
          <p className="mt-3 text-sm text-foreground-700 md:text-base">
            灵魂P图、名场面截图、表情包二创，全部免费可分享，专治各种不开心。
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 md:gap-4">
          {gallery.map((g, i) => (
            <figure
              key={g.caption}
              className="group relative overflow-hidden rounded-lg bg-background-200"
            >
              <img
                src={g.image}
                alt={`${g.caption} 火影沙雕图`}
                title={`${g.caption} 表情包`}
                className="aspect-[3/4] w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
              />
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/80 to-transparent px-3 pb-3 pt-8 text-xs text-background-50 md:text-sm">
                {g.caption}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}